import { DBSchema, IDBPDatabase, openDB } from 'idb'

interface TakaDB extends DBSchema {
  'redux-persist': {
    key: string
    value: any
  }
}

export default function createIdbStorage(dbName: string) {
  let dbPromise: Promise<IDBPDatabase<TakaDB>>

  const getDB = () => {
    if (!dbPromise) {
      dbPromise = openDB<TakaDB>(dbName, 1, {
        upgrade(db) {
          db.createObjectStore('redux-persist')
        },
      })
    }
    return dbPromise
  }

  return {
    async getItem(key: string): Promise<string | null> {
      try {
        const db = await getDB()
        const result = await db.get('redux-persist', key)
        return result ? JSON.stringify(result) : null
      } catch (error) {
        console.warn('IndexedDB getItem failed:', error)
        return null
      }
    },

    async setItem(key: string, value: string): Promise<void> {
      try {
        const db = await getDB()
        await db.put('redux-persist', JSON.parse(value), key)
      } catch (error) {
        console.warn('IndexedDB setItem failed:', error)
      }
    },

    async removeItem(key: string): Promise<void> {
      try {
        const db = await getDB()
        await db.delete('redux-persist', key)
      } catch (error) {
        console.warn('IndexedDB removeItem failed:', error)
      }
    },
  }
}
